import {ReactNode, Ref, MouseEvent as ReactMouseEvent} from 'react';

import {pushGtmEvent} from 'shared/web';

import {MenuButton} from './MenuButton';
import {MenuLink} from './MenuLink';

interface MenuItemLinkOrButtonProps {
  to: string;
  isGroup: boolean;
  children: ReactNode;
  onClick: () => void;
  action?: () => void | Promise<void>;
  ref?: Ref<HTMLAnchorElement | HTMLButtonElement>;
}

export function MenuItemLinkOrButton(props: MenuItemLinkOrButtonProps) {
  const onClick = (event: ReactMouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    pushGtmEvent({
      event: 'button_click',
      event_id: 'sidebar_menu_item_click',
      value: props.to,
    });

    if (props.action) {
      event?.preventDefault();
      props.action();
    }

    props.onClick();
  };

  if (props.isGroup) {
    return (
      <MenuButton ref={props.ref as Ref<HTMLButtonElement>} onClick={onClick}>
        {props.children}
      </MenuButton>
    );
  }

  return (
    <MenuLink ref={props.ref as Ref<HTMLAnchorElement>} to={props.to} onClick={onClick}>
      {props.children}
    </MenuLink>
  );
}
